module.exports = __webpack_public_path__ + "static/media/job-check.6989a2ef.svg";